export const range = (from: number, to: number): number[] => {
	let items = [];
	for (var n = from; n <= to; n++) {
		items.push(n);
	}
	return items;
};

// This helper is needed because some currencies in stripe can't
// be provided in their smallest value e.g. 10 USD needs to be
// provided as 1000 cents.
export const decimalToCentsByCurrency = (cost: number, currency: string) => {
	const zeroDecimal = [
		'BIF',
		'CLP',
		'DJF',
		'GNF',
		'JPY',
		'KMF',
		'KRW',
		'MGA',
		'PYG',
		'RWF',
		'UGX',
		'VND',
		'VUV',
		'XAF',
		'XOF',
		'XPF',
	];

	return zeroDecimal.includes(currency.toUpperCase())
		? cost
		: Math.round(cost * 100);
};
